import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './globals.css';

// Initialize i18n BEFORE app renders -- this sets up language detection,
// translation loading, and document direction (RTL/LTR) management.
import '../lib/i18n';

// Initialize theme-aware favicon switching
import { initializeFaviconThemeSwitcher } from '../utils/faviconThemeSwitcher';

/**
 * Main entry point for HajiQube Frontend
 * Uses React 18 createRoot API for concurrent features
 */
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

// Initialize theme-aware favicon switching
initializeFaviconThemeSwitcher();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
